import { SvgProps } from "../../types";

export default function ChevronUpIcon({ stroke }: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="none"
            stroke={stroke || "#0b132b"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-chevron-up"
        >
            <polyline points="18 15 12 9 6 15" />
        </svg>
    );
}
